// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"176":"projects","443":"about"}[chunkId] || chunkId) + "." + {"176":"2a8bd652","443":"9ef00bb8","745":"3a4ff451"}[chunkId] + ".js";
};